export const CHAT_HISTORY_PAGE_SIZE = 20;
export const CHAT_HISTORY_AFTER_PARAM = 'after';
export const CHAT_HISTORY_BEFORE_PARAM = 'before';
export const CHAT_HISTORY_TRUNCATE_LENGTH = 50;
